var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.3 21.6",
    style: {
      enableBackground: "new 0 0 25.3 21.6"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M16.4,18.2c-1.8,1.7-5.3,2.7-9.1,1.1c-4.7-1.9-7-7.3-5.1-12c0.9-2.3,2.7-4.1,5-5s4.8-1,7-0.1l0.2,0.1h0 c0.8,0.3,1.4,0.8,2,1.4c0.3,0.3,0.8,0.3,1.1,0c0.3-0.3,0.3-0.8,0-1.1c-0.7-0.8-1.7-1.4-2.7-1.8c-2.7-1.1-5.6-1-8.2,0.1 C3.9,2,1.9,4.1,0.8,6.7c-2.2,5.5,0.4,11.8,5.9,14c1.5,0.6,3,0.9,4.4,0.9c2.6,0,4.9-1,6.3-2.3c0.3-0.3,0.3-0.8,0-1.1 C17.1,17.9,16.7,17.9,16.4,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M20.4,5.7c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1l3.1,3.1H10.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h12.2 l-3.1,3.4c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.2l4.8-5.2L20.4,5.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.373e711720b48250676659465fc97f52.svg";
export { ForwardRef as ReactComponent };